import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import AccessArea from './accessArea';
import AccessAreas from './accessAreas';
import AccessGroup from "./accessGroup";
import AccessGroups from "./accessGroups";
import AccessProfile from './accessProfile';
import AccessProfiles from "./accessProfiles";
import AccessTimePattern from './accessTimePattern';
import AccessTimePatterns from './accessTimePatterns';
import Categories from './categories';
import Companies from "./companies";
import Company from './company';
import Department from './department';
import Departments from './departments';
import Enrolments from './enrolments';
import Personnel from './personnel';

function getPageForRoute(key: string, selectedTab: number, setSelectedTab: React.Dispatch<React.SetStateAction<number>>) {
    const selected = {
        'personnel': <Personnel />,
        'company': <Company />,
        'companies': <Companies />,
        'departments': <Departments />,
        'department': <Department />,
        'access-area': <AccessArea areaType={1} />,
        'lift-area': <AccessArea areaType={2}/>,
        'access-areas': <AccessAreas selected={selectedTab} setSelected={setSelectedTab} />,
        'access-groups': <AccessGroups selected={selectedTab} setSelected={setSelectedTab} />,
        'access-group': <AccessGroup accessType={1} />,
        'floor-group': <AccessGroup accessType={2} />,
        'oss-group': <AccessGroup accessType={3} />,
        'access-profiles': <AccessProfiles />,
        'access-profile': <AccessProfile />,
        'access-time-pattern': <AccessTimePattern />,
        'access-time-patterns': <AccessTimePatterns />,
        'categories': <Categories />,
    }[key];

    if (selected) { return selected; }
    return <Enrolments
        selected={selectedTab}
        setSelected={setSelectedTab} />;
}

function getKeyFromPath(path) {
    const contentKey = 3;
    const key = path.split('/')[contentKey];
    return key;
}

const EnrolmentIndex = () => {
    const page: string = useSelector((state: any) => state.router.location.pathname);
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const key = getKeyFromPath(page);
    useEffect(() => {
        setSelectedTab(0);
    }, [key]);
    return getPageForRoute(key, selectedTab, setSelectedTab)
}

export default EnrolmentIndex;
